import React from "react";
import styles from "./ImageCard.module.scss";

const ImageCard = ({ imgSrc, title, imgHeight = 168 }) => {
  return (
    <div className={styles.wrapper}>
      <div className="container">
        <div className="image-container" style={{ height: imgHeight }}>
          <img src={imgSrc} alt={title} />
        </div>
        <p className="title">{title}</p>
      </div>
    </div>
  );
};

export default ImageCard;
